// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type DispositiveProvisions_DispositiveProvisionTemplateFragment = { __typename?: 'DispositiveProvisionTemplate', id: string, displayName: string, proRata: boolean, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number, edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
        { __typename?: 'DispositiveProvision' }
        & DispositiveProvisions_DispositiveProvisionFragment
      ) | null } | null> | null } };

export type DispositiveProvisions_DispositiveProvisionFragment = { __typename?: 'DispositiveProvision', id: string, dispositionAmount?: CurrencyUSD | null, dispositionKind: Types.DispositiveProvisionDispositionKind, dispositionOrder: number, dispositionPercentage?: Percent | null, dispositionFormulaicPercentage?: Percent | null, notes?: string | null, recipientKind?: Types.DispositiveProvisionRecipientKind | null, transferTaxKind: Types.DispositiveProvisionTransferTaxKind, transferMethod: Types.TransferMethod, bearsTax: boolean, dispositionLimit?: CurrencyUSD | null, growByInflation: boolean, associatedHypotheticalWaterfall?: { __typename?: 'EstateWaterfall', id: string } | null, entity?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, kind?: Types.ClientOrganizationKind | null, name: string } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, displayName: string, kind: Types.TestamentaryEntityKind } | null, assetGroups?: Array<{ __typename?: 'AssetGroup', id: string, name: string }> | null, assetStatics?: Array<{ __typename?: 'AssetStatic', id: string, name: string }> | null, insurancePolicies?: Array<{ __typename?: 'InsurancePolicy', id: string, carrierName?: string | null, deathBenefitAmount: CurrencyUSD }> | null, ownershipStakes?: Array<{ __typename?: 'OwnershipStake', id: string, ownershipPercentage?: Percent | null, ownedEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null }> | null };

export type DispositiveProvisions_DispositionScenarioFragment = { __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null, transferMethod?: Types.TransferMethod | null, firstDeathResiduaryPaysAllTaxes?: boolean | null, secondDeathResiduaryPaysAllTaxes?: boolean | null, associatedHypotheticalWaterfall?: { __typename?: 'EstateWaterfall', id: string } | null, firstGrantorDeath: { __typename?: 'ClientProfile', id: string, displayName: string }, dispositiveProvisionsTemplate?: (
    { __typename?: 'DispositiveProvisionTemplate' }
    & DispositiveProvisions_DispositiveProvisionTemplateFragment
  ) | null, secondDeathDispositiveProvisionsTemplate?: (
    { __typename?: 'DispositiveProvisionTemplate' }
    & DispositiveProvisions_DispositiveProvisionTemplateFragment
  ) | null, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number, edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
        { __typename?: 'DispositiveProvision' }
        & DispositiveProvisions_DispositiveProvisionFragment
      ) | null } | null> | null }, secondDeathDispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number, edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
        { __typename?: 'DispositiveProvision' }
        & DispositiveProvisions_DispositiveProvisionFragment
      ) | null } | null> | null } };

export type DispositiveProvisions_BeneficiaryDesignationGroupFragment = { __typename?: 'BeneficiaryDesignationGroup', id: string, tier: Types.BeneficiaryDesignationTier, residuaryPaysAllTaxes: boolean, associatedHypotheticalWaterfall?: { __typename?: 'EstateWaterfall', id: string } | null, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number, edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
        { __typename?: 'DispositiveProvision' }
        & DispositiveProvisions_DispositiveProvisionFragment
      ) | null } | null> | null } };

export type DispositiveProvisions_BeneficiaryDesignationsFragment = { __typename?: 'BeneficiaryDesignations', primary?: (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & DispositiveProvisions_BeneficiaryDesignationGroupFragment
  ) | null, contingent?: (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & DispositiveProvisions_BeneficiaryDesignationGroupFragment
  ) | null };

export const Operations = {
  Fragment: {
    DispositiveProvisions_DispositiveProvisionTemplate: 'DispositiveProvisions_DispositiveProvisionTemplate' as const,
    DispositiveProvisions_DispositiveProvision: 'DispositiveProvisions_DispositiveProvision' as const,
    DispositiveProvisions_DispositionScenario: 'DispositiveProvisions_DispositionScenario' as const,
    DispositiveProvisions_BeneficiaryDesignationGroup: 'DispositiveProvisions_BeneficiaryDesignationGroup' as const,
    DispositiveProvisions_BeneficiaryDesignations: 'DispositiveProvisions_BeneficiaryDesignations' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DispositiveProvisions_DispositiveProvisionFragmentDoc = gql`
    fragment DispositiveProvisions_DispositiveProvision on DispositiveProvision {
  id
  dispositionAmount
  dispositionKind
  dispositionOrder
  dispositionPercentage
  dispositionFormulaicPercentage
  associatedHypotheticalWaterfall {
    id
  }
  entity {
    id
    kind
    subtype {
      id
      displayName
    }
  }
  individual {
    id
    displayName
  }
  notes
  organization {
    id
    kind
    name
  }
  recipientKind
  testamentaryEntity {
    id
    displayName
    kind
  }
  transferTaxKind
  transferMethod
  bearsTax
  dispositionLimit
  growByInflation
  assetGroups {
    id
    name
  }
  assetStatics {
    id
    name
  }
  insurancePolicies {
    id
    carrierName
    deathBenefitAmount
  }
  ownershipStakes {
    id
    ownedEntity {
      id
      subtype {
        id
        displayName
      }
    }
    ownershipPercentage
  }
}
    `;
export const DispositiveProvisions_DispositiveProvisionTemplateFragmentDoc = gql`
    fragment DispositiveProvisions_DispositiveProvisionTemplate on DispositiveProvisionTemplate {
  id
  displayName
  proRata
  dispositiveProvisions {
    totalCount
    edges {
      node {
        ...DispositiveProvisions_DispositiveProvision
      }
    }
  }
}
    ${DispositiveProvisions_DispositiveProvisionFragmentDoc}`;
export const DispositiveProvisions_DispositionScenarioFragmentDoc = gql`
    fragment DispositiveProvisions_DispositionScenario on DispositionScenario {
  id
  reviewedAt
  associatedHypotheticalWaterfall {
    id
  }
  transferMethod
  firstGrantorDeath {
    id
    displayName
  }
  dispositiveProvisionsTemplate {
    ...DispositiveProvisions_DispositiveProvisionTemplate
  }
  secondDeathDispositiveProvisionsTemplate {
    ...DispositiveProvisions_DispositiveProvisionTemplate
  }
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositiveProvisions_DispositiveProvision
      }
    }
  }
  secondDeathDispositiveProvisions(
    orderBy: {direction: ASC, field: DISPOSITION_ORDER}
  ) {
    totalCount
    edges {
      node {
        ...DispositiveProvisions_DispositiveProvision
      }
    }
  }
  firstDeathResiduaryPaysAllTaxes
  secondDeathResiduaryPaysAllTaxes
}
    ${DispositiveProvisions_DispositiveProvisionTemplateFragmentDoc}
${DispositiveProvisions_DispositiveProvisionFragmentDoc}`;
export const DispositiveProvisions_BeneficiaryDesignationGroupFragmentDoc = gql`
    fragment DispositiveProvisions_BeneficiaryDesignationGroup on BeneficiaryDesignationGroup {
  id
  tier
  residuaryPaysAllTaxes
  associatedHypotheticalWaterfall {
    id
  }
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositiveProvisions_DispositiveProvision
      }
    }
  }
}
    ${DispositiveProvisions_DispositiveProvisionFragmentDoc}`;
export const DispositiveProvisions_BeneficiaryDesignationsFragmentDoc = gql`
    fragment DispositiveProvisions_BeneficiaryDesignations on BeneficiaryDesignations {
  primary {
    ...DispositiveProvisions_BeneficiaryDesignationGroup
  }
  contingent {
    ...DispositiveProvisions_BeneficiaryDesignationGroup
  }
}
    ${DispositiveProvisions_BeneficiaryDesignationGroupFragmentDoc}`;